import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

import { IPropsType as IChatboxV2PropsType } from '../../../Routes/renderer/chatBoxV2'

interface IConfig extends Omit<IChatboxV2PropsType, 'type' | 'sendStoreId'> {
  enableChat: boolean
}

const defaultConfig: IConfig = {
  enableChat: false,
  agentCode: 'systemwide-guest',
}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'wingitnorth':
      case 'fw_wingstop':
        return {
          ...defaultConfig,
          enableChat: true,
          hideFromNonExpoUsers: true,
        }

      case 'timoney_bk':
      case 'bibibop':
      case 'ghai_pop':
      case 'irmg_bk':
        return {
          ...defaultConfig,
          enableChat: true,
        }

      default:
        return defaultConfig
    }
  }, [brand])
}
